import { FC } from 'react';

import classes from './Footer.module.scss';
import KakakoMap from '../../assets/kakaomap.webp';
import NaverMap from '../../assets/navermap.webp';
import TMap from '../../assets/tmap.webp';

const Footer: FC = () => {
  return (
    <footer className={classes.invitationFooter}>
      <h2>아펠가모 공덕 마리에 홀</h2>
      <div className={classes.navigationLinks}>
        <a href="https://naver.me/xkqe4oJD" rel="noreferrer" target="_blank">
          <img src={NaverMap} alt="네이버맵" />
        </a>
        <a href="http://kko.to/yIAl1HUMv1" rel="noreferrer" target="_blank">
          <img src={KakakoMap} alt="카카오맵" />
        </a>
        <a
          href="https://surl.tmap.co.kr/0834c5c3"
          rel="noreferrer"
          target="_blank"
        >
          <img src={TMap} alt="티맵" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
